import { render, staticRenderFns } from "./ValidateEmail.vue?vue&type=template&id=01df600e&"
import script from "./ValidateEmail.vue?vue&type=script&lang=js&"
export * from "./ValidateEmail.vue?vue&type=script&lang=js&"
import style0 from "./ValidateEmail.vue?vue&type=style&index=0&id=01df600e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports